import React from 'react';
import ReactDOM from 'react-dom/client';
import Portfolio from './component/intro'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Portfolio />
);

